
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-us",
      function () {
        return require("private-next-pages/es-us/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-us"])
      });
    }
  